import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './styles.css'
import { App } from './App'

// A deploy replaces the content-hashed chunks; a session that started on the
// old build fails its next lazy import (QuizFlow, BrandRail, details). Reload
// once to pick up the new build; the timestamp guard stops a reload loop when
// the server itself is unreachable.
window.addEventListener('vite:preloadError', (event) => {
  const KEY = 'vite-preload-reload-at'
  const last = Number(sessionStorage.getItem(KEY) || 0)
  if (Date.now() - last < 10_000) return
  sessionStorage.setItem(KEY, String(Date.now()))
  event.preventDefault()
  window.location.reload()
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
)
